module.exports = __webpack_public_path__ + "img/region.5da73f0e.svg";